import { setOptions, importLibrary } from '@googlemaps/js-api-loader';

let map;


async function initMap() {

    const [, { AdvancedMarkerElement, PinElement }] = await Promise.all([
        google.maps.importLibrary('maps'),
        google.maps.importLibrary('marker'),
    ]);

    const mapElement = document.querySelector('.block-boarders-map gmp-map');
	const innerMap = mapElement?.innerMap;

    if (!innerMap) {
        console.warn('Map not ready / innerMap not found');
        return;
    }

    // Set map options.
	innerMap.setOptions({
		cameraControl: false,
		fullscreenControl: false,
		mapTypeControl: false,
		scaleControl: false,
		streetViewControl: false,
	});

    if (!window.boarderLocations) {
        console.warn('No boarder locations found');
        return;
    }

    window.boarderLocations.forEach((markerData) => {
        const countryFlagImg = new URL(
            `/app/themes/woodbridge/assets/images/flags-circle/${markerData.country_code.toLowerCase()}.svg`,
            location.origin
        ).href;
        // import.meta.url
        const countryFlagPinElement = new PinElement({
            background: '#0057B7',
            borderColor: '#0057B7',
            glyphSrc: countryFlagImg,
            scale: 1.25,
        });


        const countryFlagMarker = new AdvancedMarkerElement({
            map: innerMap,
            position: { lat: parseFloat(markerData.lat), lng: parseFloat(markerData.lng) },
            title: markerData.marker_title ?? markerData.country_name,
        });

        countryFlagMarker.append(countryFlagPinElement);

        countryFlagMarker.addListener('gmp-click', () => {
            /*
            infoWindow.setContent(`<div class="boarder-infowindow"><h3>${markerData.country_name}</h3><p>${markerData.student_count} student${markerData.student_count > 1 ? 's' : ''}</p></div>`);
            infoWindow.open({
                anchor: countryFlagMarker,
                map: innerMap,
            });
            */

            const nationalitySelect = document.querySelector(
                '.block-boarders-grid-wrap select[name="nationalities[]"]'
            );

            if (nationalitySelect) {
                const countryCode = markerData.country_code.toLowerCase();
                const matchingOption = nationalitySelect.querySelector(
                    '[data-boarder-filter-country-code="' + countryCode + '"]'
                );

                nationalitySelect.value = matchingOption ? matchingOption.value : '';
                jQuery(nationalitySelect).trigger('change');
            }

            const bordersGrid = document.querySelector('.block-boarders-grid-wrap');
            if (bordersGrid) {
                bordersGrid.scrollIntoView({ behavior: 'smooth' });
            }

        });
    });
}

function toggleHighlight(flagMarker) {
    if (flagMarker.content.classList.contains('highlight')) {
        flagMarker.content.classList.remove('highlight');
        flagMarker.zIndex = null;
    }
    else {
        flagMarker.content.classList.add('highlight');
        flagMarker.zIndex = 1;
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const boardersMap = document.querySelector('.block-boarders-map');
    if (boardersMap) {
        initMap();
    }
});